import { render, staticRenderFns } from "./Openings.vue?vue&type=template&id=2dce83d3&scoped=true&"
import script from "./Openings.vue?vue&type=script&lang=ts&"
export * from "./Openings.vue?vue&type=script&lang=ts&"
import style0 from "./Openings.vue?vue&type=style&index=0&id=2dce83d3&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dce83d3",
  null
  
)

export default component.exports